import React, { useEffect, useMemo, useState } from "react";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import { Modal, Form, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { getRequest } from "services/api";
import { buildQueryString } from "utils/queryHelpers";
import "./accounting-v2.css";
import "./fb-daily-recap.css";

const sectionTemplates = [
  {
    id: "fb",
    label: "F & B",
    rows: [
      { id: "fb-1", transaction: "SOFT DRINK", profit: 710000, cost: 730000, price: 20000, qty: 71, others1: 40000, others2: 10500, others3: 0 },
      { id: "fb-2", transaction: "BIR BINTANG", profit: 200000, cost: 200000, price: 50000, qty: 8, others1: 11500, others2: 11500, others3: 0 },
      { id: "fb-3", transaction: "MINERAL WATER M,L", profit: 170000, cost: 170000, price: 10000, qty: 34, others1: 16000, others2: 10000, others3: 0 },
      { id: "fb-4", transaction: "RED BULL", profit: 325000, cost: 325000, price: 50000, qty: 13, others1: 4500, others2: 4000, others3: 0 },
      { id: "fb-5", transaction: "ICE CREAM KIND COCO 55K", profit: 33000, cost: 77000, price: 55000, qty: 2, others1: 17000, others2: 3000, others3: 0 },
      { id: "fb-6", transaction: "GELATO STICK", profit: 295650, cost: 534350, price: 30000, qty: 27, others1: 10000, others2: 4000, others3: 0 },
    ],
  },
  {
    id: "menu",
    label: "MENU",
    rows: [
      { id: "menu-1", transaction: "NASI PUTIH 10K", profit: 5000, cost: 5000, price: 10000, qty: 1, others1: 14000, others2: 11000, others3: 0 },
      { id: "menu-2", transaction: "PAPAYA SALAD 45K", profit: 0, cost: 0, price: 45000, qty: 0, others1: 23000, others2: 6000, others3: 0 },
      { id: "menu-3", transaction: "SOTO AYAM 50K", profit: 0, cost: 0, price: 50000, qty: 0, others1: 9000, others2: 8000, others3: 0 },
      { id: "menu-4", transaction: "FRENCH FRIES 40K", profit: 80000, cost: 80000, price: 40000, qty: 4, others1: 0, others2: 15500, others3: 0 },
      { id: "menu-5", transaction: "# CHICKEN 45K", profit: 45000, cost: 45000, price: 45000, qty: 2, others1: 0, others2: 6000, others3: 0 },
      { id: "menu-6", transaction: "AYAM GORENG LENGKUAS 65K", profit: 65000, cost: 65000, price: 65000, qty: 2, others1: 0, others2: 0, others3: 0 },
    ],
  },
  {
    id: "lain-lain",
    label: "LAIN-LAIN",
    rows: [
      { id: "lain-1", transaction: "VIDEO+FOTO", profit: 5800000, cost: 0, price: 0, qty: 0, others1: 0, others2: 0, others3: 0 },
      { id: "lain-2", transaction: "BAJU+CELANA", profit: 750000, cost: 0, price: 0, qty: 0, others1: 0, others2: 0, others3: 0 },
      { id: "lain-3", transaction: "WATER PROOF+SARUNG LENGAN", profit: 2500000, cost: 0, price: 0, qty: 0, others1: 0, others2: 0, others3: 0 },
      { id: "lain-4", transaction: "MANTEL", profit: 460000, cost: 0, price: 0, qty: 0, others1: 0, others2: 0, others3: 0 },
      { id: "lain-5", transaction: "KAOS KAKI", profit: 675000, cost: 0, price: 0, qty: 0, others1: 0, others2: 0, others3: 0 },
    ],
  },
  {
    id: "biaya",
    label: "BIAYA - BIAYA",
    rows: [
      { id: "biaya-1", transaction: "BELANJA DAPUR", profit: 0, cost: 350000, price: 0, qty: 0, others1: 0, others2: 0, others3: 0 },
      { id: "biaya-2", transaction: "PACKAGING", profit: 0, cost: 180000, price: 0, qty: 0, others1: 0, others2: 0, others3: 0 },
      { id: "biaya-3", transaction: "OPERASIONAL HARIAN", profit: 0, cost: 225000, price: 0, qty: 0, others1: 0, others2: 0, others3: 0 },
    ],
  },
  {
    id: "edc-mandiri",
    label: "EDC MANDIRI",
    rows: [
      { id: "edc-1", transaction: "VIDEO+FOTO", profit: 0, cost: 750000, price: 0, qty: 0, others1: 0, others2: 0, others3: 0 },
      { id: "edc-2", transaction: "CHARGE KARTU KREDIT 3%", profit: 0, cost: 0, price: 0, qty: 22500, others1: 0, others2: 0, others3: 0, alert: true },
      { id: "edc-3", transaction: "FOTO", profit: 0, cost: 400000, price: 0, qty: 0, others1: 0, others2: 0, others3: 0 },
      { id: "edc-4", transaction: "BEER", profit: 0, cost: 121000, price: 0, qty: 0, others1: 0, others2: 0, others3: 0 },
      { id: "edc-5", transaction: "CHARGE KARTU KREDIT 3%", profit: 0, cost: 0, price: 0, qty: 3630, others1: 0, others2: 0, others3: 0, alert: true },
    ],
  },
];

const dummySections = sectionTemplates.map((section) => ({
  ...section,
  rows: section.rows.map((row) => ({ ...row, isDummy: true })),
}));

const numericFields = ["profit", "cost", "price", "qty", "disc", "others1", "others2", "others3"];
// Kolom yang dijumlah di baris TOTAL. PRICE (harga satuan) & TAX % (persen) tidak bermakna kalau dijumlah.
const summableFields = ["profit", "cost", "qty", "disc", "others1", "others3"];

const parseNumber = (value) => {
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  const normalized = String(value || "").replace(/[^0-9-]/g, "");
  return Number(normalized) || 0;
};

// Format angka disamakan dengan halaman akunting lain (titik ribuan).
const formatSheetNumber = (value) => parseNumber(value).toLocaleString("id-ID", { maximumFractionDigits: 0 });
const formatPercent = (value) => `${Number(value || 0).toLocaleString("id-ID", { maximumFractionDigits: 2 })}%`;

// Tanggal lokal (WITA), bukan UTC: sebelumnya sebelum jam 08.00 pagi yang terbuka tanggal kemarin.
const toDateInputValue = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const parseDateValue = (dateValue) => new Date(`${dateValue}T12:00:00`);

const formatHeaderDate = (dateValue) => parseDateValue(dateValue).toLocaleDateString("id-ID", {
  day: "numeric",
  month: "long",
  year: "numeric",
}).toUpperCase();

const formatShortDate = (dateValue) => parseDateValue(dateValue)
  .toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" })
  .replace(/ /g, "-");

// ===== Rumus =====
// Baris penjualan (harga & qty ada):
//   SUBTOTAL  = Harga x Qty (kalau digabung: jumlah Harga x Qty tiap transaksi)
//   COST      = Modal x Qty
//   PROFIT    = SUBTOTAL - COST - DISC
//   TOTAL     = SUBTOTAL - DISC + TAX TOTAL   (pajak dihitung sekali, TAX % tidak ikut dijumlah)
// Baris lain (mis. LAIN-LAIN / BIAYA, tanpa harga & qty): TOTAL = PROFIT + COST + TAX TOTAL.
const isSalesRow = (row) => parseNumber(row.price) > 0 && parseNumber(row.qty) > 0;

const getRowSubtotal = (row) => {
  if (!isSalesRow(row)) return 0;
  return row.gross !== undefined ? parseNumber(row.gross) : parseNumber(row.price) * parseNumber(row.qty);
};

const getRowTotal = (row) => {
  if (isSalesRow(row)) return getRowSubtotal(row) - parseNumber(row.disc) + parseNumber(row.others3);
  return parseNumber(row.profit) + parseNumber(row.cost) + parseNumber(row.others3);
};

const buildRecentDates = () => {
  const dates = [];
  const today = new Date();
  for (let index = 0; index < 30; index += 1) {
    const date = new Date(today);
    date.setDate(today.getDate() - index);
    dates.push(date);
  }
  return dates;
};

const getResponseRows = (response) => {
  const data = response?.data?.data || response?.data || [];
  if (Array.isArray(data)) return data;
  return data.items || data.rows || data.reports || data.menus || [];
};

const findMasterMenu = (item, menuMaster) => {
  const menuId = item.menu_id || item.product_id || item.menu?.id || item.product?.id;
  const itemName = item.item_name || item.name || item.menu || "";
  return menuMaster.find((menu) => menuId && String(menu.id) === String(menuId))
    || menuMaster.find((menu) => String(menu.name || "").toLowerCase() === String(itemName).toLowerCase());
};

const getMenuCategory = (item, masterMenu) => masterMenu?.category?.name
  || masterMenu?.category_name
  || masterMenu?.categories?.[0]?.name
  || item.category?.name
  || item.category_name
  || item.category
  || "Tanpa Kategori";

const firstNumber = (...values) => {
  const found = values.find((value) => value !== undefined && value !== null && value !== "");
  return found === undefined ? undefined : Number(found) || 0;
};

// Bentuk data /transaction/report (per menu per hari), contoh:
//   qty 19, price 380.000, min_price 10.000, tax 38.000, tax_percent 10,
//   total_amount_before_tax "380000.00", total_tax_amount "38000.00", total_amount_after_tax "418000.00"
// -> `price` di laporan adalah TOTAL baris (sebelum pajak), bukan harga per pcs; `min_price` per pcs.
// Jadi harga per pcs = total sebelum pajak ÷ qty, dan PROFIT dihitung per pcs lalu dikali qty.
const buildFinancialValues = (item, masterMenu, quantity) => {
  const qty = Number(quantity ?? item.quantity ?? item.qty ?? item.total_quantity ?? 0) || 0;
  const itemPrice = firstNumber(item.price);
  const lineBeforeTax = firstNumber(item.total_amount_before_tax);
  const masterPrice = Number(masterMenu?.price) || 0;

  // Deteksi `price` = total baris: sama dengan total sebelum pajak, atau = harga master × qty.
  const priceIsLineTotal = itemPrice !== undefined && qty > 1 && (
    (lineBeforeTax !== undefined && Math.abs(itemPrice - lineBeforeTax) < 1)
    || (lineBeforeTax === undefined && masterPrice > 0 && Math.abs(itemPrice - masterPrice * qty) < 1)
  );
  const gross = lineBeforeTax
    ?? (itemPrice !== undefined ? (priceIsLineTotal ? itemPrice : itemPrice * qty) : masterPrice * qty);
  const unitPrice = qty > 0 ? gross / qty : (itemPrice ?? masterPrice);

  const itemMinPrice = firstNumber(item.min_price);
  const minPrice = itemMinPrice ?? (Number(masterMenu?.min_price) || 0);
  const disc = firstNumber(item.discount, item.discount_amount, item.total_discount) || 0;
  const cost = minPrice * qty;

  const taxPercent = firstNumber(item.tax_percent, item.tax_rate) || 0;
  const taxAmount = firstNumber(item.tax_amount, item.tax) || 0;
  const reportedTaxTotal = firstNumber(item.total_tax_amount, item.tax_total);
  // TAX TOTAL dipakai sekali di TOTAL. Kalau laporan tidak mengirim total pajak, pakai nominal pajak,
  // atau hitung dari persen pajak × (subtotal − diskon).
  const taxTotal = reportedTaxTotal ?? (taxAmount || Math.round(((gross - disc) * taxPercent) / 100));
  const taxTotalSource = reportedTaxTotal !== undefined
    ? "laporan"
    : taxAmount ? "nominal pajak" : taxPercent ? "persen" : "kosong";

  return {
    price: unitPrice,
    qty,
    disc,
    gross,
    cost,
    // PROFIT = (Harga per pcs − Modal per pcs) × Qty − Diskon  (= Subtotal − Cost − Diskon)
    profit: gross - cost - disc,
    minPrice,
    priceSource: lineBeforeTax !== undefined
      ? "total sebelum pajak ÷ qty"
      : priceIsLineTotal ? "price laporan (total baris) ÷ qty" : itemPrice !== undefined ? "laporan" : "master menu",
    minPriceSource: itemMinPrice !== undefined ? "laporan" : "master menu",
    others1: taxAmount,
    others2: taxPercent,
    others3: taxTotal,
    taxTotalSource,
    // Untuk cek silang TOTAL hitungan FE vs total sesudah pajak dari laporan.
    reportedTotal: firstNumber(item.total_amount_after_tax),
  };
};

// Menu dengan nama sama di kategori yang sama digabung: nilai uang & qty dijumlah,
// harga jadi rata-rata (subtotal / qty), TAX % tidak dijumlah.
const groupRowsByCategory = (rows) => Object.entries(rows.reduce((groups, row) => {
  const category = row.category || "Tanpa Kategori";
  if (!groups[category]) groups[category] = [];
  const existing = groups[category].find((groupRow) => groupRow.transaction.toLowerCase() === row.transaction.toLowerCase());
  if (existing) {
    ["profit", "cost", "qty", "disc", "gross", "others1", "others3"].forEach((field) => {
      existing[field] += row[field];
    });
    existing.reportedTotal = existing.reportedTotal !== undefined && row.reportedTotal !== undefined
      ? existing.reportedTotal + row.reportedTotal
      : undefined;
    existing.mergedCount += 1;
    if (existing.price !== row.price) existing.priceVaries = true;
    if (existing.others2 !== row.others2) existing.taxPercentVaries = true;
    if (existing.minPrice !== row.minPrice) existing.minPriceVaries = true;
    existing.price = existing.qty ? existing.gross / existing.qty : existing.price;
    existing.minPrice = existing.qty ? existing.cost / existing.qty : existing.minPrice;
  } else {
    groups[category].push({ ...row, mergedCount: 1 });
  }
  return groups;
}, {})).map(([category, categoryRows]) => ({
  id: `category-${category.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`,
  label: category,
  rows: categoryRows.map(({ category: unusedCategory, ...row }) => row),
}));

const buildSectionsFromReports = (dailyReport, menuMaster = []) => {
  const dailyRows = Array.isArray(dailyReport) ? dailyReport : [];
  const menuRows = dailyRows.map((item, index) => {
    const masterMenu = findMasterMenu(item, menuMaster);
    return {
      id: `menu-api-${item.menu_id || item.menu || index}`,
      transaction: masterMenu?.name || item.menu_name || item.menu || item.name || "MENU",
      category: getMenuCategory(item, masterMenu),
      ...buildFinancialValues(item, masterMenu, item.qty ?? item.total_quantity),
    };
  });
  const apiMenuSections = groupRowsByCategory(menuRows);
  return [
    ...(apiMenuSections.length ? apiMenuSections : dummySections.slice(0, 2)),
    dummySections[2],
    dummySections[3],
    dummySections[4],
  ];
};

// ===== Info hover: arti kolom + hasil kalkulasi =====
const COLUMN_INFO = {
  profit: "PROFIT = (Harga per pcs − Modal per pcs) × Qty − Diskon. Keuntungan kotor dari penjualan menu.",
  cost: "COST = Modal per pcs (min price) × Qty. Total harga modal barang yang terjual.",
  price: "PRICE = harga jual per pcs (total sebelum pajak ÷ qty). Kalau harga berbeda antar transaksi, ini rata-ratanya.",
  qty: "QTY = jumlah item terjual.",
  disc: "DISC = total diskon dari laporan transaksi. Mengurangi PROFIT dan TOTAL.",
  others1: "TAX = nominal pajak dari laporan transaksi (informasi).",
  others2: "TAX % = persentase pajak. Tidak dijumlah di baris TOTAL.",
  others3: "TAX TOTAL = total pajak yang ditambahkan ke TOTAL (dihitung sekali).",
  total: "TOTAL = Harga × Qty − Diskon + Tax Total. Untuk baris tanpa harga/qty: Profit + Cost + Tax Total.",
};

const n = formatSheetNumber;

const getCellInfo = (row, field) => {
  const lines = [COLUMN_INFO[field]];
  const isManual = row.minPrice === undefined;
  if (row.isDummy) lines.push("Data contoh (DUMMY), tidak ikut dihitung ke total.");

  switch (field) {
    case "profit":
      if (isManual || !isSalesRow(row)) lines.push(`Nilai diisi manual: ${n(row.profit)}`);
      else {
        const marginPerPcs = parseNumber(row.price) - parseNumber(row.minPrice);
        lines.push(
          `= (${n(row.price)} − ${n(row.minPrice)}) × ${n(row.qty)} − ${n(row.disc)}`,
          `= ${n(marginPerPcs)} × ${n(row.qty)} − ${n(row.disc)}   ← profit per pcs dulu`,
          `= ${n(marginPerPcs * parseNumber(row.qty))} − ${n(row.disc)}`,
          `= ${n(row.profit)}`
        );
      }
      break;
    case "cost":
      if (isManual) lines.push(`Nilai diisi manual: ${n(row.cost)}`);
      else {
        lines.push(`= ${n(row.minPrice)} × ${n(row.qty)} = ${n(row.cost)}`);
        lines.push(row.minPriceSource === "laporan"
          ? "Modal dari laporan transaksi."
          : "Modal dari master menu (harga modal saat ini, bisa beda dengan saat transaksi).");
        if (row.minPriceVaries) lines.push("Modal berbeda antar transaksi, ditampilkan rata-ratanya.");
      }
      break;
    case "price":
      lines.push(`Harga per pcs: ${n(row.price)}${row.priceSource ? ` (dari ${row.priceSource})` : ""}`);
      if (row.gross !== undefined && parseNumber(row.qty) > 0) lines.push(`= ${n(getRowSubtotal(row))} ÷ ${n(row.qty)} = ${n(row.price)}`);
      if (row.mergedCount > 1) lines.push(`Gabungan ${row.mergedCount} transaksi. Subtotal ${n(getRowSubtotal(row))} ÷ ${n(row.qty)} qty.`);
      if (row.priceVaries) lines.push("Harga berbeda antar transaksi, ditampilkan rata-ratanya.");
      break;
    case "qty":
      lines.push(`Qty: ${n(row.qty)}${row.mergedCount > 1 ? ` (gabungan ${row.mergedCount} transaksi)` : ""}`);
      break;
    case "disc":
      lines.push(parseNumber(row.disc) ? `Diskon: ${n(row.disc)}` : "Tidak ada diskon di laporan.");
      break;
    case "others1":
      lines.push(`Nominal pajak: ${n(row.others1)}`);
      break;
    case "others2":
      lines.push(`Persen pajak: ${formatPercent(row.others2)}`);
      if (row.taxPercentVaries) lines.push("Persen pajak berbeda antar transaksi yang digabung.");
      break;
    case "others3":
      lines.push(`Tax total: ${n(row.others3)}`);
      if (row.taxTotalSource === "persen") lines.push(`Dihitung: (${n(getRowSubtotal(row))} − ${n(row.disc)}) × ${formatPercent(row.others2)}`);
      else if (row.taxTotalSource === "nominal pajak") lines.push("Laporan tidak mengirim total pajak, memakai nominal pajak.");
      else if (row.taxTotalSource === "laporan") lines.push("Dari laporan transaksi.");
      break;
    case "total":
      if (isSalesRow(row)) {
        lines.push(`= (${n(row.price)} × ${n(row.qty)}) − ${n(row.disc)} + ${n(row.others3)}`);
        lines.push(`= ${n(getRowSubtotal(row))} − ${n(row.disc)} + ${n(row.others3)} = ${n(getRowTotal(row))}`);
        if (row.reportedTotal !== undefined) {
          const diff = getRowTotal(row) - parseNumber(row.reportedTotal);
          lines.push(Math.abs(diff) < 1
            ? `✓ Sama dengan total sesudah pajak di laporan (${n(row.reportedTotal)}).`
            : `⚠ Beda ${n(diff)} dengan total sesudah pajak di laporan (${n(row.reportedTotal)}).`);
        }
      } else {
        lines.push(`= ${n(row.profit)} + ${n(row.cost)} + ${n(row.others3)} = ${n(getRowTotal(row))}`);
      }
      break;
    default:
      break;
  }
  return lines;
};

const TOTAL_INFO = {
  profit: "Jumlah PROFIT semua baris",
  cost: "Jumlah COST semua baris",
  price: "Harga satuan tidak dijumlah",
  qty: "Jumlah QTY semua baris",
  disc: "Jumlah diskon semua baris",
  others1: "Jumlah nominal TAX semua baris",
  others2: "Persen pajak tidak dijumlah",
  others3: "Jumlah TAX TOTAL semua baris",
  grandTotal: "Jumlah TOTAL semua baris",
};

const InfoTip = ({ lines, children, placement = "top" }) => (
  <OverlayTrigger
    placement={placement}
    delay={{ show: 80, hide: 0 }}
    overlay={(
      <Tooltip className="fb-recap-tip">
        {lines.filter(Boolean).map((line, index) => (
          <div key={index} className={index === 0 ? "fb-recap-tip-title" : "fb-recap-tip-line"}>{line}</div>
        ))}
      </Tooltip>
    )}
  >
    <div className="fb-recap-tip-target">{children}</div>
  </OverlayTrigger>
);

const FbDailyRecapPage = () => {
  const [selectedDate, setSelectedDate] = useState(toDateInputValue(new Date()));
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [tempDate, setTempDate] = useState(toDateInputValue(new Date()));
  const [sections, setSections] = useState(dummySections);
  const [activeCell, setActiveCell] = useState(null);
  const [isLoadingReports, setIsLoadingReports] = useState(false);
  const [reportError, setReportError] = useState("");

  const recentDates = useMemo(() => buildRecentDates(), []);

  useEffect(() => {
    let cancelled = false;
    const loadReports = async () => {
      setIsLoadingReports(true);
      setReportError("");
      const reportQuery = buildQueryString({
        "filter[start_date]": selectedDate,
        "filter[end_date]": selectedDate,
      });
      try {
        const [dailyResponse, menuResponse] = await Promise.all([
          getRequest(`/transaction/report${reportQuery}`),
          getRequest("/menu?all=1&include=categories"),
        ]);
        if (!cancelled) setSections(buildSectionsFromReports(getResponseRows(dailyResponse), getResponseRows(menuResponse)));
      } catch (error) {
        if (!cancelled) {
          setReportError("Data API belum tersedia, sementara menampilkan template contoh.");
          setSections(dummySections);
        }
      } finally {
        if (!cancelled) setIsLoadingReports(false);
      }
    };
    loadReports();
    return () => { cancelled = true; };
  }, [selectedDate]);

  const totals = useMemo(() => {
    const emptyTotal = { ...Object.fromEntries(summableFields.map((field) => [field, 0])), grandTotal: 0 };

    return sections.reduce((acc, section) => {
      const sectionTotal = section.rows.reduce((rowAcc, row) => {
        if (row.isDummy) return rowAcc;
        summableFields.forEach((field) => {
          rowAcc[field] += parseNumber(row[field]);
        });
        rowAcc.grandTotal += getRowTotal(row);
        return rowAcc;
      }, { ...emptyTotal });

      acc.bySection[section.id] = sectionTotal;
      summableFields.forEach((field) => {
        acc.grand[field] += sectionTotal[field];
      });
      acc.grand.grandTotal += sectionTotal.grandTotal;
      return acc;
    }, { bySection: {}, grand: { ...emptyTotal } });
  }, [sections]);

  const updateRowValue = (sectionId, rowId, field, value) => {
    setSections((prevSections) =>
      prevSections.map((section) => {
        if (section.id !== sectionId) return section;

        return {
          ...section,
          rows: section.rows.map((row) => {
            if (row.id !== rowId) return row;
            const nextRow = {
              ...row,
              [field]: numericFields.includes(field) ? parseNumber(value) : value,
            };
            // Baris dari laporan (modal diketahui): ubah harga / qty / diskon -> hitung ulang subtotal, cost, profit.
            if (["price", "qty", "disc"].includes(field) && row.minPrice !== undefined) {
              nextRow.gross = parseNumber(nextRow.price) * parseNumber(nextRow.qty);
              nextRow.cost = parseNumber(nextRow.minPrice) * parseNumber(nextRow.qty);
              nextRow.profit = nextRow.gross - nextRow.cost - parseNumber(nextRow.disc);
              nextRow.mergedCount = 1;
              nextRow.priceVaries = false;
              if (row.taxTotalSource === "persen") {
                nextRow.others3 = Math.round(((nextRow.gross - parseNumber(nextRow.disc)) * parseNumber(nextRow.others2)) / 100);
              }
            }
            return nextRow;
          }),
        };
      })
    );
  };

  const addRow = (sectionId) => {
    setSections((prevSections) =>
      prevSections.map((section) => {
        if (section.id !== sectionId) return section;
        return {
          ...section,
          rows: [
            ...section.rows,
            {
              id: `${sectionId}-${Date.now()}`,
              transaction: "",
              profit: 0,
              cost: 0,
              price: 0,
              qty: 0,
              disc: 0,
              others1: 0,
              others2: 0,
              others3: 0,
            },
          ],
        };
      })
    );
  };

  const handleOpenDatePicker = () => {
    setTempDate(selectedDate);
    setShowDatePicker(true);
  };

  const handleSelectDate = (dateValue) => {
    setSelectedDate(dateValue);
  };

  const renderMoneyInput = (sectionId, row, field, rowIndex) => {
    const cellKey = `${row.id}-${field}`;
    const isActive = activeCell === cellKey;
    const displayValue = field === "others2" ? formatPercent(row[field]) : formatSheetNumber(row[field]);

    return (
      <InfoTip lines={getCellInfo(row, field)}>
        <input
          className="fb-recap-cell-input text-end"
          data-row={rowIndex}
          data-col={field}
          value={isActive ? row[field] : displayValue}
          onFocus={(event) => {
            setActiveCell(cellKey);
            const input = event.currentTarget;
            window.requestAnimationFrame(() => input.select());
          }}
          onBlur={(event) => {
            updateRowValue(sectionId, row.id, field, event.target.value);
            setActiveCell(null);
          }}
          onChange={(event) => updateRowValue(sectionId, row.id, field, event.target.value)}
        />
      </InfoTip>
    );
  };

  const renderTotalCell = (total, field, scopeLabel) => {
    const notSummed = field === "price" || field === "others2";
    return (
      <td>
        <InfoTip lines={[`${TOTAL_INFO[field]} ${scopeLabel}.`, notSummed ? "Ditampilkan –" : `= ${formatSheetNumber(total?.[field] || 0)}`]}>
          {notSummed ? "–" : formatSheetNumber(total?.[field] || 0)}
        </InfoTip>
      </td>
    );
  };

  const headerCell = (label, info, className) => (
    <th className={className}>
      <InfoTip lines={[label, info]} placement="bottom">{label}</InfoTip>
    </th>
  );

  return (
    <LayoutDashboard>
      <div className="container-fluid py-3 pb-5 mb-5 fb-recap-container">
        <div className="fb-recap-toolbar">
          <div className="fb-recap-toolbar-note">
            <span className="fb-recap-status-dot" />
            {isLoadingReports ? "Memuat laporan" : "Sumber: Transactions History + Daily Report Resto"}
          </div>
          <div className="fb-recap-title-wrap">
            <h3>TRANSAKSI HARIAN KUBER BALI ADVENTURE</h3>
            <h4>TANGGAL : {formatHeaderDate(selectedDate)}</h4>
          </div>
          <div className="fb-recap-actions">
            <button type="button" className="btn btn-sm btn-outline-dark">
              Export
            </button>
          </div>
        </div>

        {reportError && <div className="alert alert-warning py-2 mb-3">{reportError}</div>}

        <div className="fb-recap-summary-strip">
          <InfoTip lines={["Total Profit", "Jumlah PROFIT semua baris (data contoh/DUMMY tidak dihitung).", `= ${formatSheetNumber(totals.grand.profit)}`]}>
            <div>
              <span>Total Profit</span>
              <strong>{formatSheetNumber(totals.grand.profit)}</strong>
            </div>
          </InfoTip>
          <InfoTip lines={["Total Cost", "Jumlah COST (modal × qty) semua baris.", `= ${formatSheetNumber(totals.grand.cost)}`]}>
            <div>
              <span>Total Cost</span>
              <strong>{formatSheetNumber(totals.grand.cost)}</strong>
            </div>
          </InfoTip>
          <InfoTip lines={["Total Qty", "Jumlah item terjual semua baris.", `= ${formatSheetNumber(totals.grand.qty)}`]}>
            <div>
              <span>Total Qty</span>
              <strong>{formatSheetNumber(totals.grand.qty)}</strong>
            </div>
          </InfoTip>
          <InfoTip lines={[
            "Grand Total",
            "Jumlah TOTAL semua baris (Harga × Qty − Diskon + Tax Total).",
            `= ${formatSheetNumber(totals.grand.grandTotal)}`,
            `Termasuk diskon −${formatSheetNumber(totals.grand.disc)} dan pajak +${formatSheetNumber(totals.grand.others3)}.`,
          ]}>
            <div>
              <span>Grand Total</span>
              <strong>{formatSheetNumber(totals.grand.grandTotal)}</strong>
            </div>
          </InfoTip>
        </div>

        <div className="fb-recap-table-shell">
          <table className="table table-sm fb-recap-table mb-0">
            <thead>
              <tr>
                <th className="fb-recap-date-col">TGL</th>
                <th className="fb-recap-transaction-col">TRANSAKSI</th>
                {headerCell("PROFIT", COLUMN_INFO.profit, "fb-recap-profit-col")}
                {headerCell("COST", COLUMN_INFO.cost, "fb-recap-cost-col")}
                {headerCell("PRICE", COLUMN_INFO.price, "fb-recap-price-col")}
                {headerCell("QTY", COLUMN_INFO.qty)}
                {headerCell("DISC", COLUMN_INFO.disc, "fb-recap-muted-col")}
                {headerCell("TAX", COLUMN_INFO.others1, "fb-recap-others-col")}
                {headerCell("TAX %", COLUMN_INFO.others2, "fb-recap-others-col")}
                {headerCell("TAX TOTAL", COLUMN_INFO.others3, "fb-recap-others-col")}
                {headerCell("TOTAL", COLUMN_INFO.total, "fb-recap-total-col")}
              </tr>
            </thead>
            <tbody>
              {sections.map((section) => (
                <React.Fragment key={section.id}>
                  <tr className="fb-recap-section-row">
                    <td />
                    <td>{section.label}</td>
                    <td colSpan="9">
                      <button type="button" onClick={() => addRow(section.id)}>
                        + Tambah baris
                      </button>
                    </td>
                  </tr>
                  {section.rows.map((row, rowIndex) => (
                    <tr key={row.id} className={[row.alert && "fb-recap-alert-row", row.isDummy && "fb-recap-dummy-row"].filter(Boolean).join(" ")}>
                      <td className="text-center">{formatShortDate(selectedDate)}</td>
                      <td>
                        <input
                          className="fb-recap-cell-input fb-recap-name-input"
                          value={row.transaction}
                          onChange={(event) => updateRowValue(section.id, row.id, "transaction", event.target.value)}
                        />
                        {row.isDummy && <span className="fb-recap-dummy-badge">DUMMY</span>}
                      </td>
                      <td className="fb-recap-profit-col">{renderMoneyInput(section.id, row, "profit", rowIndex)}</td>
                      <td className="fb-recap-cost-col">{renderMoneyInput(section.id, row, "cost", rowIndex)}</td>
                      <td className="fb-recap-price-col">{renderMoneyInput(section.id, row, "price", rowIndex)}</td>
                      <td>{renderMoneyInput(section.id, row, "qty", rowIndex)}</td>
                      <td className="fb-recap-muted-col">{renderMoneyInput(section.id, row, "disc", rowIndex)}</td>
                      <td>{renderMoneyInput(section.id, row, "others1", rowIndex)}</td>
                      <td>{renderMoneyInput(section.id, row, "others2", rowIndex)}</td>
                      <td>{renderMoneyInput(section.id, row, "others3", rowIndex)}</td>
                      <td className="fb-recap-grand-cell">
                        <InfoTip lines={getCellInfo(row, "total")}>{formatSheetNumber(getRowTotal(row))}</InfoTip>
                      </td>
                    </tr>
                  ))}
                  <tr className="fb-recap-total-row">
                    <td />
                    <td>TOTAL</td>
                    {renderTotalCell(totals.bySection[section.id], "profit", `di ${section.label}`)}
                    {renderTotalCell(totals.bySection[section.id], "cost", `di ${section.label}`)}
                    {renderTotalCell(totals.bySection[section.id], "price", `di ${section.label}`)}
                    {renderTotalCell(totals.bySection[section.id], "qty", `di ${section.label}`)}
                    {renderTotalCell(totals.bySection[section.id], "disc", `di ${section.label}`)}
                    {renderTotalCell(totals.bySection[section.id], "others1", `di ${section.label}`)}
                    {renderTotalCell(totals.bySection[section.id], "others2", `di ${section.label}`)}
                    {renderTotalCell(totals.bySection[section.id], "others3", `di ${section.label}`)}
                    {renderTotalCell(totals.bySection[section.id], "grandTotal", `di ${section.label}`)}
                  </tr>
                </React.Fragment>
              ))}
              <tr className="fb-recap-grand-row">
                <td />
                <td>GRAND TOTAL</td>
                {["profit", "cost", "price", "qty", "disc", "others1", "others2", "others3", "grandTotal"].map((field) => (
                  <React.Fragment key={field}>{renderTotalCell(totals.grand, field, "di semua kategori (DUMMY tidak dihitung)")}</React.Fragment>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        <div className="accounting-v2-bottom-bar" style={{ marginLeft: "var(--sidebar-width, 0)" }}>
          <div
            className="date-tab-year"
            onClick={handleOpenDatePicker}
            title="Pilih tanggal custom"
          >
            {new Date(selectedDate).getFullYear()}
          </div>

          <div className="bottom-date-selector">
            {recentDates.map((date) => {
              const value = toDateInputValue(date);
              const active = value === selectedDate;
              const dateLabel = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}`;

              return (
                <div
                  key={value}
                  className={`date-tab ${active ? "active" : ""}`}
                  onClick={() => handleSelectDate(value)}
                >
                  <span className="date-tab-day">{dateLabel}</span>
                </div>
              );
            })}
          </div>
        </div>

        <Modal show={showDatePicker} onHide={() => setShowDatePicker(false)} centered size="sm">
          <Modal.Header closeButton>
            <Modal.Title className="h5 mb-0">Pilih Tanggal</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              type="date"
              value={tempDate}
              onChange={(event) => setTempDate(event.target.value)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDatePicker(false)}>
              Batal
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                if (tempDate) {
                  handleSelectDate(tempDate);
                }
                setShowDatePicker(false);
              }}
            >
              Pilih
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </LayoutDashboard>
  );
};

export default FbDailyRecapPage;
